<template>
    <div :style="backgroundStyle(item)">
        <login-in v-if="isAlonePage"
            :loginType="loginType"
            :isLoginFlag="isLoginFlag"
            :activityUrl="activityUrl">
        </login-in>
        <!-- 权益包内容 -->
        <div class="package-contain">
            <div class="package-item"
                :style="{'padding-bottom': showBeneficialProducts ? '10px' : '0'}">
                <!-- 权益包 -->
                <div class="large-contain">
                    <div class="price-contain">
                        <img class="main-img"
                            :src="item.mainImg">
                    </div>
                    <div class="product-info">
                        <div class="product-title ellipsis-text">{{ item.packageName }}</div>
                        <div class="receive-time ellipsis-text">{{ getPackageRecTime(item) }}</div>
                        <div class="btn-contain">
                            <!-- 未到领取时间，显示倒计时 -->
                            <themaicCountDown v-if="item.recieveTime > 0 && item.useStatus === '09'"
                                class="large-contain-mask"
                                :countColor="countColor"
                                :blockColor="blockColor"
                                :blockBackgroundColor="blockBackgroundColor"
                                :time="item.recieveTime"
                                @timeDownFinished="timeDownFinished(index)"></themaicCountDown>
                            <div class="count"
                                :style="wordsColorStyle(item)">
                                <span v-if="item.showRemainingAmountWay === '1' && item.balanceAmount > 99999">剩余99999+</span>
                                <span
                                    v-if="item.showRemainingAmountWay === '1' && item.balanceAmount <= 99999 && item.balanceAmount > 0">剩余：{{ item.balanceAmount }}</span>
                                <span v-if="item.showRemainingAmountWay === '1' && item.balanceAmount === 0">剩余：0</span>
                                <span v-if="item.showRemainingAmountWay === '2' && item.balanceAmount >= 1 && item.balanceAmount <= 100">数量较少</span>
                                <span v-if="item.showRemainingAmountWay === '2' && item.balanceAmount > 100">数量充裕</span>
                            </div>
                            <div class="bottom-btn">
                                <div class="open-icon"
                                    @click="handleClickOpen()">
                                    <span>{{ showBeneficialProducts?'收起':'展开' }}</span>
                                    <img v-show="showBeneficialProducts"
                                        class="open-img"
                                        src="static/runtime/images/magic/uparrow.png"
                                        alt />
                                    <img v-show="!showBeneficialProducts"
                                        class="open-img"
                                        src="static/runtime/images/magic/downarrow.png"
                                        alt />
                                </div>
                                <!-- 立即领取：权益包未领取；已领取：至少有一个权益品领取成功；已过期：权益包已过期 -->
                                <div class="main-btn-user-vip">
                                    <!-- XX专享标签 -->
                                    <div v-if="showRestrictTypeName(item)"
                                        class="user-vip">
                                        {{ item.activityPageRewardSettingList[0].restrictTypeName }}</div>
                                    <!-- 立即领取 -->
                                    <template v-if="item.groupUseFlag === EQUITY_PACKAGE_STATUS.UN_RECEIVE">
                                        <!-- 满足新老用户限制，显示立即领取 -->
                                        <div v-if="item.activityPageRewardSettingList[0].isShow"
                                            class="get-btn"
                                            @click="receiveEquityPackage(item)">
                                            <img class="get-btn-img"
                                                :src="item.receiveButtonImgUrl">
                                        </div>
                                        <!-- 不满足新老用户限制，显示不可领取 -->
                                        <div v-else
                                            class="not-received-btn  margin-top-btn">
                                            <img class="not-received-btn-img"
                                                :src="item.notReceiveButtonImgUrl">
                                        </div>
                                    </template>
                                    <!-- 已领取 -->
                                    <div v-if="item.groupUseFlag === EQUITY_PACKAGE_STATUS.RECEIVED"
                                        class="main-btn received-btn">已领取</div>
                                    <!-- 已过期 -->
                                    <div v-if="item.groupUseFlag === EQUITY_PACKAGE_STATUS.EXPIRED"
                                        class="main-btn received-btn">已过期</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="showBeneficialProducts"
                class="bottom-line"></div>
            <!-- 权益品或者代金券楼层 -->
            <!--权益品内容，样式1*1-->
            <div v-show="showBeneficialProducts">
                <div v-if="item.filePath&&item.backgroundType=='image'">
                    <img class="coupon-corner-img"
                        :src="item.filePath"
                        @click="toCorrespondingFloor(item)">
                </div>
                <template>
                    <!-- 权益品 -->
                    <div v-for="(item1,index) in item.goodsList"
                        :key="index"
                        class="beneficial-item-large">
                        <div class="large-contain"
                            :style="getCardStyle(item1)">
                            <div v-if="isExchangeVoucher(item, index)"
                                class="voucher-corner">
                                <img class="voucher-corner-img"
                                    :src="item1.voucherCornerPic">
                            </div>
                            <div v-if="isExchangeCoupon(item, index)"
                                class="voucher-corner">
                                <img class="voucher-corner-img"
                                    :src="item1.couponCornerPic">
                            </div>
                            <div class="price-contain">
                                <img class="main-img"
                                    :src="item1.mainImg">
                            </div>
                            <div class="product-info">
                                <div class="product-title ellipsis-text">{{ item1.exchangeGoodsName }}</div>
                                <div v-if="item.groupUseFlag !== EQUITY_PACKAGE_STATUS.UN_RECEIVE"
                                    class="receive-time ellipsis-text">{{ getProductRecTime(item1) }}</div>
                                <div class="btn-contain">
                                    <!-- 未到领取时间，显示倒计时 -->
                                    <themaicCountDown v-if="item1.recieveTime > 0 && item1.useStatus === '09'"
                                        class="large-contain-mask"
                                        :countColor="countColor"
                                        :blockColor="blockColor"
                                        :blockBackgroundColor="blockBackgroundColor"
                                        :time="item1.recieveTime"
                                        @timeDownFinished="timeDownFinished(index)"></themaicCountDown>
                                    <div v-if="item.groupUseFlag !== EQUITY_PACKAGE_STATUS.UN_RECEIVE"
                                        class="btn-user-vip">
                                        <!-- 所有状态 01立即领取 02已领取 05已使用 09暂不可领 10已过期 11已领完 13去使用 15去填写 -->
                                        <div v-if="item1.useStatus === '01'">
                                            <!-- 立即领取 -->
                                            <div v-if="item1.isShow"
                                                class="get-btn"
                                                @click="receiveAward(item,index)">
                                                <img class="get-btn-img"
                                                    :src="item1.receiveButtonImgUrl">
                                            </div>
                                            <!-- 不可领取 -->
                                            <div v-else
                                                class="not-received-btn margin-top-btn">
                                                <img class="not-received-btn-img"
                                                    :src="item1.notReceiveButtonImgUrl">
                                            </div>
                                        </div>
                                        <!-- 已领取 -->
                                        <div v-if="item1.useStatus === '02'"
                                            class="received-btn"
                                            @click="toUse(item,index)">已领取</div>
                                        <!-- 已使用 -->
                                        <img v-if="item1.useStatus === '05'"
                                            class="coupon-received"
                                            src="static/runtime/images/magic/used.png">
                                        <!-- 暂不可领 -->
                                        <div v-if="item1.useStatus === '09' || item1.useStatus === '1502'"
                                            class="not-received-btn">
                                            <img class="not-received-btn-img"
                                                :src="item1.notReceiveButtonImgUrl">
                                        </div>
                                        <!-- 已过期 -->
                                        <img v-if="isShowExpiredTag(item1.useStatus)"
                                            class="coupon-received"
                                            src="static/runtime/images/magic/expired.png">
                                        <!-- 超过领取时间 -->
                                        <img v-if="item1.useStatus === '08'"
                                            class="coupon-received"
                                            src="static/runtime/images/magic/exceedReceiveTime.png">
                                        <!-- 已领完 -->
                                        <img v-if="item1.useStatus === '11'"
                                            class="coupon-received"
                                            src="static/runtime/images/magic/received.png">
                                        <!-- 去使用 -->
                                        <div v-if="item1.useStatus === '13'"
                                            class="get-btn"
                                            @click="toUseDetails(item,index)">
                                            <img class="get-btn-img"
                                                :src="item1.exchangeButtonImgUrl">
                                        </div>
                                        <!-- 实物-线上邮寄、虚拟-线上兑换 -->
                                        <div v-if="item1.useStatus === useStatus.TO_FILL"
                                            class="to-fill-in-btn"
                                            @click="toFillIn(item,index)">
                                            去填写
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <!-- 实物权益品到店自提 -->
        <receiveAwardModal ref="receiveAwardModal"
            :activityUrl="activityUrl"
            :awardObj="awardObj"
            :activityObj="activityObj"
            :drawType="drawType"
            :miniFlag="miniprogramFlag"
            @openKindAwardModal="openKindAwardModal"></receiveAwardModal>
        <!-- 虚拟权益品用户信息录入弹窗 -->
        <codeCancelAfterVerfication v-if="codeShow"
            :awardObj="awardObj"
            :goodsIndex="goodsIndex"
            :codeUrl="awardObj.writeOffCodeUrl"
            :writeOffCode="awardObj.writeOffCode"
            :extendConfigFlag="awardObj.extendConfigFlag"
            :activationCode="awardObj.activationCode"
            :effectiveStartTime="awardObj.effectiveStartTime"
            :effectiveEndTime="awardObj.effectiveEndTime"
            @closeEnd="closeEnd"
            @getExchangeGoodsToUrl="getExchangeGoodsToUrl"></codeCancelAfterVerfication>
        <!-- 虚拟权益品用户信息录入弹窗 -->
        <virtualOnlineAwardModal ref="virtualOnlineAwardModal"
            :awardObj="awardObj"
            :userInfoList="userInfoList"
            :userBase="{}"
            :goodsIndex="goodsIndex"
            :isReceived="isReceived"
            @handleVirtualOnline="fillInUserInfo(arguments)"
            @openVirtualAwardModal="openVirtualAwardModal"
            @getExchangeGoodsToUrl="getExchangeGoodsToUrl"></virtualOnlineAwardModal>
        <!-- 实物权益品用户信息录入 -->
        <kindAwardModal ref="kindAwardModal"
            :awardObj="awardObj"
            :activityObj="activityObj"
            :referrFlag="userBase.referrFlag"
            @nextStep="nextStep"></kindAwardModal>
        <!-- 实物线上邮寄用户信息录入 -->
        <realOnlineMailingModal ref="realOnlineMailingModal"
            :awardObj="awardObj"
            :userBase="userBase"
            :goodsIndex="goodsIndex"
            @handleRealOnlineMailing="handleRealOnlineMailing(arguments)"
            @nextStep="nextStep"></realOnlineMailingModal>
        <!-- 活动暂停 -->
        <suspend-dialog v-if="backgroundType"
            :showDialog="activitySuspended"
            img="static/runtime/images/magic/signIn/sign-in-pause.png"
            text="活动已暂停"></suspend-dialog>
        <!-- 领取权益品、代金券的时候验证身份的弹框 -->
        <identityVerifyDialog :isShowIdentityDialog.sync="isShowIdentityDialog"
            :verifyTitle="cashCouponVerifyTitle"
            :activityUrl="activityUrl"
            :isShowCheckBtn="isShowCheckBtn"
            :activityCode="activityCode"
            :clickListId="elementParentObjId"
            :clickIndex="clickIndex"
            :pageSource="'thematicActivity'"
            :isClickNextPage="isClickNextPage"
            :loginType="loginType"
            :identityTypeList="identityTypeList"
            :clickElementObj="clickElementObj"
            :checkChannel="checkChannel"
            :receiveAward="receiveAward"
            :receiveEquityPackage="receiveEquityPackage"></identityVerifyDialog>
        <!-- 抽奖对象配置，企微好友控制，企微导购弹窗 -->
        <qywx-guide-limit-modal ref="qywxGuideLimit"
            :activityType="ActivityType.thematicActivity"></qywx-guide-limit-modal>
        <!-- 抽奖对象配置，社群用户控制，社群活码弹窗 -->
        <community-user-limit-modal ref="communityUserLimit"
            :activityType="ActivityType.thematicActivity"
            :activityCode="activityCode"></community-user-limit-modal>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import kindAwardModal from '../dynamicAttr/modal/kindAwardModal.vue';
import receiveAwardModal from '../dynamicAttr/modal/receiveAwardModal.vue';
import themaicCountDown from '../themaicComponent/themaic-count-down.vue';
import codeCancelAfterVerfication from '../../../../components/modal/code-cancel-after-verification.vue';
import { Dialog, Toast } from 'vant';
import virtualOnlineAwardModal from '../dynamicAttr/modal/virtual-online.vue';
import realOnlineMailingModal from '../../../../components/modal/real-online-mailing-modal.vue';
import loginIn from '../dynamicAttr/modal/login-in.vue';
import {
  ExchangeGoodsType,
  CollectionType,
  PMLinkType,
  useStatus,
  CustomerGroup,
  CouponType,
  LoginType,
  EnableMessageNotifications,
  HTTP_STATUS,
  EQUITY_PACKAGE_STATUS,
  USER_RESTRICTIONS_FLAG,
  ActivityType,
  SkuScopeType,
  JumpType,
} from '../../../../commons/commonVariables.js';
import utils, { AllLoginTypeHandler } from '../../../../utils/comUtils.js';
import suspendDialog from '../../../../components/modal/suspend-dialog.vue';
import { jumpToPointsMall, getValidity, pointsMallLinkJudge, getGoodsList, userLimitHandler, jumpToNext } from '../common-methods/utils';
import identityVerifyDialog from '../dynamicAttr/identityVerifyDialog.vue';
import qywxGuideLimitModal from '../dynamicAttr/modal/qywxGuideLimitModal.vue';
import communityUserLimitModal from '../dynamicAttr/modal/communityUserLimitModal.vue';

export default {
  components: {
    themaicCountDown,
    kindAwardModal,
    receiveAwardModal,
    codeCancelAfterVerfication,
    virtualOnlineAwardModal,
    realOnlineMailingModal,
    loginIn,
    suspendDialog,
    identityVerifyDialog,
    qywxGuideLimitModal,
    communityUserLimitModal,
  },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    miniprogramFlag: {
      type: Boolean,
      default: true,
    },
    enableMessageNotifications: {
      type: String,
      default: '',
    },
    mobileVerification: {
      type: String,
      default: '',
    },
    smallIndexExchangeGoods: {
      type: Number,
      default: null,
    },
    bigItemExchangeGoods: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activitySuspended: false,
      pageId: '',
      backgroundType: '',
      pageType: '',
      userUnionid: '',
      alipayUserId: '',
      countColor: '#FFFFFF',
      blockColor: '#000',
      blockBackgroundColor: '#FFFFFF',
      item: {},
      activityUrl: '', // 当前活动地址
      awardObj: {},
      goodsIndex: 0,
      userBase: {},
      isReceived: false,
      activityObj: {},
      drawType: 'initDraw',
      loginType: '',
      isLoginFlag: false, // 默认没有登录
      activityCode: '',
      userInfoList: [],
      codeShow: false,
      usedFlag: '',
      adminRegions: {}, //首页行政区域ID对象，入参获取奖品的时候接口
      isShowIdentityDialog: false, //是否展示优惠券或者代金券的身份验证弹框
      cashCouponVerifyTitle: '', //展示代金券的身份验证弹框的内容
      mobileVerificationRouter: '', //pc配置为图片而非背景时，h5点击图片做编程式跳转传过来的mobileVerification 值为新老用户
      identityType: '',
      identityTypeList: [], //多方认证返回身份list
      isShowCheckBtn: true, //是否展示去验证按钮
      clickIndex: null, //当前选中券的index
      isClickNextPage: 'false', //是否点击了下级页面
      elementParentObjId: '', //当前选中券的父对象的id
      clickElementObj: {}, //当前选中的券对象
      isAlonePage: false, // 是否为独立的页面
      checkChannel: 3,
      useStatus: useStatus,
      showBeneficialProducts: true,
      EQUITY_PACKAGE_STATUS: EQUITY_PACKAGE_STATUS,
      equityPkgIdentityType: '',
      equityPkgIdentityTypeList: [], //多方认证返回身份list
      USER_RESTRICTIONS_FLAG: USER_RESTRICTIONS_FLAG,
      ActivityType: ActivityType,
    };
  },
  computed: {
    // 权益品是否是代金券
    isExchangeVoucher() {
      return (item, index) => {
        return item.groupVOList[index].exchangeGoodsType === ExchangeGoodsType.voucher;
      };
    },
    // 权益品是否是优惠券
    isExchangeCoupon() {
      return (item, index) => {
        return item.groupVOList[index].exchangeGoodsType === ExchangeGoodsType.coupon;
      };
    },
  },
  watch: {
    detail: {
      handler(val) {
        console.log('val==', val);
        if (val) {
          this.item = val;
          this.showBeneficialProducts = val.activityPageRewardSettingList[0].groupUseFlag !== '0';
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    if (this.$route.query.pageId && this.$route.query.activityCode) {
      // 图片楼层
      this.isAlonePage = true;
      this.pageType = this.$route.query.pageType;
      this.activityCode = this.$route.query.activityCode;
      this.backgroundType = this.$route.query.backgroundType;
      this.miniprogramFlag = this.$route.query.miniprogramFlag === 'true';
      this.pageId = this.$route.query.pageId;
      this.mobileVerificationRouter = this.$route.query.mobileVerification;
      this.isClickNextPage = 'true';
      // 权益品/代金券
      if (this.pageType === CouponType.EQUITY_PACKAGE) {
        document.title = '权益包领取列表';
      }

      this.userUnionid = sessionStorage.getItem('userUnionid') || '';
      this.alipayUserId = sessionStorage.getItem('alipayUserId') || '';
      this.handleListQuery();
    } else {
      // 背景楼层
      this.isAlonePage = false;
    }
    // 初始化用户信息
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    this.userBase = Object.assign({}, userInfo);
    this.loginType = sessionStorage.getItem('loginType') || '';
    const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
    this.activityCode = (this.$route.query && this.$route.query.activityCode) || '';
    // 组装当前地址
    this.activityUrl = location.origin + '/hd/hdmain?activityCode=' + this.activityCode;
    if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
      this.activityUrl =
        this.activityUrl + '&ay=' + eventTrackingData.activityType + '&GUID=' + eventTrackingData.guideUserId + '&SC=' + eventTrackingData.storeCode;
    }
    this.isLoginFlag = sessionStorage.getItem('isLoginFlag') === 'true';
    this.adminRegions = JSON.parse(sessionStorage.getItem('adminRegions')) || {};
    // 芝麻身份(学生 医生 护士,教师）、微信学生、EDU教育认证完身份后重新调用领权益包接口
    const isFirst = sessionStorage.getItem('isFirst') || 'true';
    if (this.bigItemExchangeGoods && this.bigItemExchangeGoods.id && isFirst === 'true') {
      sessionStorage.setItem('isFirst', 'false');
      this.receiveEquityPackage(this.bigItemExchangeGoods, Number(this.smallIndexExchangeGoods));
    }
  },
  methods: {
    // 是否显示过期标签
    isShowExpiredTag(status) {
      return [useStatus.exceedUseTime].includes(status);
    },
    handleListQuery() {
      const loginType = this.loginType === LoginType.Wechat ? 'wxapp' : this.loginType === LoginType.Alipay ? 'alipaymini' : '';
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/queryActivityProject',
        //如果为空，就传空参数，登陆类型为微信登陆但没有登陆时，unionId需要传空字符
        notFilterNull: true,
        params: {
          activityCode: this.activityCode,
          unionId: this.userUnionid,
          alipayUserId: this.alipayUserId,
          loginType: loginType,
        },
        success: (r) => {
          const { code, result } = r;
          if (code === 200 && result) {
            result.loginType = AllLoginTypeHandler(result.loginType);
            const { activityPageList = [], loginType, activityStatus, receiveButtonImgUrl, notReceiveButtonImgUrl } = result;
            this.loginType = loginType;
            activityPageList.forEach((ii, index) => {
              if (ii.pageType === this.pageType && ii.id === this.pageId) {
                const item = activityPageList[index];
                const packageInfo = item.activityPageRewardSettingList[0];
                console.log('packageInfo', packageInfo);
                item.mainImg = this.$utils.getImageUrl(JSON.parse(packageInfo.goodsPictureUrl).file);
                item.packageName = packageInfo.exchangeGroupName;
                item.showRemainingAmountWay = result.showRemainingAmountWay;
                item.balanceAmount = packageInfo.remainingNum;
                item.groupUseFlag = packageInfo.groupUseFlag;
                this.item = item;
                this.showBeneficialProducts = item.activityPageRewardSettingList[0].groupUseFlag !== '0';
              }
            });
            // 权益品楼层和代金券楼层
            // 获取角标图片路径(代金券才有)
            if (result.activityConfig.voucherCornerPic) {
              const voucherCornerPic = JSON.parse(result.activityConfig.voucherCornerPic);
              this.item.voucherCornerPic = this.$utils.getImageUrl(voucherCornerPic.file || '');
            }
            // 获取角标图片路径(优惠券才有)
            if (result.activityConfig.couponCornerPic) {
              const couponCornerPic = JSON.parse(result.activityConfig.couponCornerPic);
              this.item.couponCornerPic = this.$utils.getImageUrl(couponCornerPic.file || '');
            }
            // 获取立即领取-按钮图片路径
            if (receiveButtonImgUrl) {
              const receiveBtnImgUrl = JSON.parse(receiveButtonImgUrl);
              this.item.receiveButtonImgUrl = this.$utils.getImageUrl(receiveBtnImgUrl.file || '');
            } else {
              this.item.receiveButtonImgUrl = require('../../../../../static/runtime/images/magic/receiveButtonImgUrl.png');
            }
            // 获取不可领取-按钮图片路径
            if (notReceiveButtonImgUrl) {
              const notReceiveBtnImgUrl = JSON.parse(notReceiveButtonImgUrl);
              this.item.notReceiveButtonImgUrl = this.$utils.getImageUrl(notReceiveBtnImgUrl.file || '');
            } else {
              this.item.notReceiveButtonImgUrl = require('../../../../../static/runtime/images/magic/notReceiveButtonImgUrl.png');
            }
            this.$set(this.item, 'goodsList', getGoodsList(result, this.item));
            this.activitySuspended = activityStatus === '2';
            this.item &&
              this.item.activityPageRewardSettingList.forEach((el) => {
                this.showClaimNowButton(el);
              });
            this.item.goodsList.forEach((el) => {
              this.showClaimNowButton(el);
            });
            const isClickNextPage = sessionStorage.getItem('isClickNextPage');
            // 芝麻身份(学生 医生 护士,教师）、微信学生、EDU教育认证完身份后重新调用领权益包接口
            if (isClickNextPage === 'true') {
              const index = sessionStorage.getItem('clickIndex');
              this.receiveEquityPackage(this.item, Number(index));
            }
          }
        },
        failure: (error) => {
          console.log('err======', error);
          Toast('出错了，请稍后再试');
        },
      });
    },
    // 是否满足新老用户限制条件判断
    showClaimNowButton(el) {
      const mobileVerification = this.mobileVerification || this.mobileVerificationRouter;
      // 为新老用户，则判断身份是否符合，符合则显示立即领取，不符合则显示不可领取
      el.isShow = true;
      if ([CustomerGroup.newOldUser].includes(el.restrictType) && el.userAuthenticationValue !== mobileVerification) {
        el.isShow = false;
      }
    },
    // 展示XXX专享标签
    showRestrictTypeName(item) {
      const activityPageRewardSettingItem = (item.activityPageRewardSettingList && item.activityPageRewardSettingList[0]) || {};
      return (
        (activityPageRewardSettingItem.userRestrictionsFlag === USER_RESTRICTIONS_FLAG.YES || activityPageRewardSettingItem.restrictType !== '0') &&
        activityPageRewardSettingItem.restrictTypeName
      );
    },
    backgroundStyle(item) {
      const style = {};
      if (this.backgroundType === 'image') {
        style.backgroundColor = '#f8f8f8';
        style.height = '100vh';
        style.paddingTop = '6px';
        style.paddingBottom = '6px';
        style.overflowY = 'auto';
      } else {
        if (item && item.filePath && item.backgroundType === 'image') {
          style.background = `url('+ ${item.filePath}+') no-repeat`;
        } else {
          style.backgroundColor = item.backgroundContent;
        }
      }
      return style;
    },
    getCardStyle(item) {
      const style = {};
      // 透明度修改
      if ([useStatus.used, useStatus.exceedUseTime, useStatus.hasReceivedAll, useStatus.exceedRecTime].includes(item.useStatus)) {
        style.opacity = 0.7;
      } else {
        style.opacity = 1;
      }
      return style;
    },
    containTagStyle(item) {
      // 已领完，置灰
      if (item.useStatus === '11') {
        return 'contain-tag-grey';
        // 特定用户领取 || 未到领取时间 透明度修改
      } else if (item.useStatus === '14' || (item.recieveTime > 0 && item.useStatus === '09')) {
        return 'contain-tag-opacity';
      }
    },
    mainImgStyle(item) {
      // 已领完 || 特定用户领取 || 未到领取时间图片 透明度修改
      if (['05', '11', '14'].includes(item.useStatus)) {
        return 'main-img-opacity';
      }
      if (item.recieveTime > 0 && item.useStatus === '09') {
        return 'main-img-opacity';
      }
    },
    couponNameStyle(item) {
      // 已领完 || 特定用户领取 || 未到领取时间图片 透明度修改
      if (['05', '10', '11', '14'].includes(item.useStatus)) {
        return 'coupon-name-opacity';
      }
      if (item.recieveTime > 0 && item.useStatus === '09') {
        return 'coupon-name-opacity';
      }
    },
    wordsColorStyle(item) {
      const style = {};
      // 未到领取时间图片 透明度修改
      if (item.recieveTime > 0 && item.useStatus === '09') {
        style.color = '#BFBFBF';
      } else {
        style.color = item.wordsColor;
      }
      return style;
    },
    // 权益包-立即领取
    async receiveEquityPackage(item, index = 0) {
      if (!this.isLoginFlag) {
        this.$utils.tips.message('warning', '登录后参与活动哦！');
        return;
      }
      if (!this.userBase && !this.userBase.accessToken && !this.userBase.userToken) {
        Toast('请登录后再试');
        return;
      }
      const params = {
        activityId: item.activityId,
        activityCode: item.activityCode,
        exchangeGroupCode: item.activityPageRewardSettingList[index].exchangeGroupCode,
        nickName: this.userBase.nickName || '', // 用户昵称
        userRewardRegion: this.adminRegions, //行政区域ID
      };
      if (item.activityPageRewardSettingList[index].restrictType === CustomerGroup.multimodalVerification) {
        this.identityType = item.activityPageRewardSettingList[index].userAuthenticationValue; // 用户未验证过学生/教师/医护身份，去校验组件验证时的入参
        this.identityTypeList = this.identityType && this.identityType.split(',');
      }
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/activityProjectReceiveALLAward',
        params: params,
        success: (r) => {
          if (r && r.code === HTTP_STATUS.SUCCESS) {
            if (this.activityPausedHandler(r)) {
              Toast('领取成功');
              // 权益包领取成功，更新权益包领取状态、数量，刷新页面（更新权益包内权益品领取状态）
              item.groupUseFlag = this.EQUITY_PACKAGE_STATUS.RECEIVED;
              item.balanceAmount -= 1;
              this.refreshPage();
            }
            // 权益包楼层埋码
            this.handleClickFloorProcess('equityPackage');
          } else {
            // 权益包领取失败处理
            this.receiveFailedHandler(r, index, item);
          }
          sessionStorage.removeItem('isClickNextPage');
          sessionStorage.removeItem('clickIndex');
          sessionStorage.removeItem('clickListId');
        },
        failure: (error) => {
          console.log('err======', error);
          Toast('出错了，请稍后再试');
        },
      });
    },
    // 权益品-立即领取
    async receiveAward(item, index) {
      if (!this.isLoginFlag) {
        this.$utils.tips.message('warning', '登录后参与活动哦！');
        return;
      }
      if (!this.userBase && !this.userBase.accessToken && !this.userBase.userToken) {
        Toast('请登录后再试');
        return;
      }
      const params = {
        activityId: item.activityId,
        activityCode: item.activityCode,
        exchangeGroupCode: item.activityPageRewardSettingList[0].exchangeGroupCode,
        exchangeGoodsCode: item.groupVOList[index].exchangeGoodsCode,
        nickName: this.userBase.nickName || '', // 用户昵称
        userRewardRegion: this.adminRegions, //行政区域ID
      };
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/activityProjectReceiveSingleAward',
        params: params,
        success: (r) => {
          if (r && r.code === 200) {
            if (this.activityPausedHandler(r)) {
              Toast('领取成功');
              // 领取成功后更新状态
              if (
                (item.groupVOList[index].exchangeGoodsType === ExchangeGoodsType.virtualAward &&
                  item.groupVOList[index].collectionType === CollectionType.expressOrOnlineCheckOff) ||
                (item.groupVOList[index].exchangeGoodsType === ExchangeGoodsType.entityAward &&
                  item.groupVOList[index].collectionType === CollectionType.expressOrOnlineCheckOff)
              ) {
                // 虚拟-线上兑换 和 实物-线上邮寄，按钮：立即领取 → 去填写
                item.goodsList[index].useStatus = useStatus.TO_FILL;
                item.groupVOList[index].useStatus = useStatus.TO_FILL;
              } else {
                // 其他权益品、优惠券、代金券和积分，按钮：立即领取 → 去使用
                item.goodsList[index].useStatus = useStatus.toUse;
                item.groupVOList[index].useStatus = useStatus.toUse;
              }
              // 领取成功后更新数量
              item.goodsList[index].balanceAmount -= 1;
              item.groupVOList[index].balanceAmount -= 1;
              item.groupVOList[index].effectiveStartTime = r.result && r.result.effectiveStartTime;
              item.goodsList[index].pickupStartTime = r.result && r.result.effectiveStartTime;
              item.groupVOList[index].effectiveEndTime = r.result && r.result.effectiveEndTime;
              item.goodsList[index].pickupEndTime = r.result && r.result.effectiveEndTime;
            }
          } else {
            // 单个权益品领取失败处理
            this.receiveFailedHandler(r, index, item);
          }
        },
        failure: (error) => {
          console.log('err======', error);
          Toast('出错了，请稍后再试');
        },
      });
    },
    // 权益品-去填写（针对虚拟-线上兑换、实物-线上邮寄）
    toFillIn(item, index) {
      this.awardObj = item;
      this.goodsIndex = index;
      const item1 = item.groupVOList[index];
      if (item1.exchangeGoodsType === ExchangeGoodsType.virtualAward && item1.collectionType === CollectionType.expressOrOnlineCheckOff) {
        // 虚拟-线上兑换，填写姓名电话
        this.userInfoList = item1.userInfoList || [];
        this.isReceived = false;
        this.$refs.virtualOnlineAwardModal.openModel();
      } else if (item1.exchangeGoodsType === ExchangeGoodsType.entityAward && item1.collectionType === CollectionType.expressOrOnlineCheckOff) {
        // 实物-线上邮寄，填写收件信息
        this.$refs.realOnlineMailingModal.openModel();
      }
    },
    // 优惠券-去使用
    toUseCoupon(item, index) {
      // 优惠券类型
      const exchangeGoodsItem = item.groupVOList[index];
      if (this.loginType === 'wechat') {
        // 在微信小程序环境打开
        if ([ExchangeGoodsType.coupon].includes(exchangeGoodsItem.exchangeGoodsType)) {
          // 包含服务商品的优惠券、免息券直接跳选购页
          if (exchangeGoodsItem.serviceGoodFlag === '2') {
            wx.miniProgram.reLaunch({
              url: `/pages/tabBar/classify/classify`,
            });
            return;
          }
          if ([SkuScopeType.moreProducts, SkuScopeType.singleProduct].includes(exchangeGoodsItem.skuScopeType) && !exchangeGoodsItem.skuCodeList) {
            // 优惠券列表跳转
            jumpToNext('', JumpType.couponPage, this.loginType, this);
          } else if (exchangeGoodsItem.skuScopeType === SkuScopeType.singleProduct) {
            // 单商品跳详情
            wx.miniProgram.navigateTo({
              url: `/subpackages/index/pages/productDetailsGlobal/product-details-global?skuCode=${exchangeGoodsItem.skuCodeList[0]}&groupCode=${exchangeGoodsItem.groupCode}&thematicActivityCode=${this.activityCode}`,
            });
          } else if (exchangeGoodsItem.skuScopeType === SkuScopeType.moreProducts) {
            // 多商品跳商品聚合页
            wx.miniProgram.navigateTo({
              url: `/subpackages/classify/pages/categories/categories?groupCode=${exchangeGoodsItem.groupCode}&skuScopeType=${exchangeGoodsItem.skuScopeType}&thematicActivityCode=${this.activityCode}`,
            });
          } else {
            // 全部商品跳选购页
            wx.miniProgram.reLaunch({
              url: `/pages/tabBar/classify/classify`,
            });
          }
        }
      } else if (this.loginType == 'Alipay') {
        // 在支付宝小程序环境打开
        if (this.miniprogramFlag) {
          // 包含服务商品的优惠券、免息券直接跳选购页
          if (exchangeGoodsItem.serviceGoodFlag === '2') {
            my.reLaunch({
              url: `/pages/tabBar/classify/classify`,
            });
            return;
          }
          // 优惠券
          if ([ExchangeGoodsType.coupon].includes(exchangeGoodsItem.exchangeGoodsType)) {
            if ([SkuScopeType.moreProducts, SkuScopeType.singleProduct].includes(exchangeGoodsItem.skuScopeType) && !exchangeGoodsItem.skuCodeList) {
              // 优惠券列表跳转
              jumpToNext('', JumpType.couponPage, this.loginType, this);
            } else if (exchangeGoodsItem.skuScopeType === SkuScopeType.singleProduct) {
              // 单商品跳详情
              my.navigateTo({
                url: `/subpackages/index/pages/productDetailsGlobal/product-details-global?skuCode=${exchangeGoodsItem.skuCodeList[0]}&groupCode=${exchangeGoodsItem.groupCode}&thematicActivityCode=${this.activityCode}`,
              });
            } else if (exchangeGoodsItem.skuScopeType === SkuScopeType.moreProducts) {
              // 多商品跳商品聚合页
              my.navigateTo({
                url: `/subpackages/classify/pages/categories/categories?groupCode=${exchangeGoodsItem.groupCode}&skuScopeType=${exchangeGoodsItem.skuScopeType}`,
              });
            } else {
              // 全部商品跳选购页
              my.reLaunch({
                url: `/pages/tabBar/classify/classify`,
              });
            }
          }
        }
      }
    },
    // 领取权益包、单个权益品失败处理
    receiveFailedHandler(r, index, item) {
      const msg = r.message ? r.message : '领取失败';
      // 权益品已过期，弹窗提示并修改状态为超过使用时间
      if (r.code === 501) {
        Dialog.alert({
          message: msg,
        }).then(() => {
          // 刷新页面
          this.refreshPage();
        });
      } else if (r.code === 1501) {
        this.handleFirstError(item, index, msg);
      } else if (r.code === 1502) {
        this.handleSecondError(msg);
      } else if (r.code === 1600) {
        userLimitHandler(r.result.userLimitStatus, ActivityType.thematicActivity, r.result.userRestrictions, 'parent', this);
      } else {
        Toast(msg);
      }
    },
    // 刷新页面
    refreshPage() {
      // 重新调接口
      if (this.$route.query.pageId) {
        this.handleListQuery();
      } else {
        this.$emit('initData');
      }
    },
    handleFirstError(item, index, msg) {
      this.isShowIdentityDialog = true;
      this.cashCouponVerifyTitle = msg;
      this.isShowCheckBtn = true;
      // 权益包
      if (item.pageType === CouponType.EQUITY_PACKAGE) {
        if (item.activityPageRewardSettingList[index].restrictType === CustomerGroup.multimodalVerification) {
          this.clickIndex = index;
          this.elementParentObjId = item.id;
          this.clickElementObj = item;
        }
      }
    },
    handleSecondError(msg) {
      this.isShowIdentityDialog = true;
      this.cashCouponVerifyTitle = msg;
      this.isShowCheckBtn = false;
    },

    // 处理三种权益品类型数据 + 打开弹窗
    // 1.权益品实物+到店自提； 2.权益品虚拟+线下核销发卡密 ； 3.权益品虚拟+线下核销
    async handleExchangeGoodsData(item, index, result, receivedNow) {
      // 中奖弹框按钮样式写死
      this.activityObj.extendConfig = {
        awardPopupButtonColor: '',
      };
      item.writeOffCode = result.writeOffCode; //核销码
      item.writeOffCodeUrl = result.writeOffCodeUrl; //核销码url
      item.effectiveStartTime = result.effectiveStartTime; //有效开始日期
      item.effectiveEndTime = result.effectiveEndTime; //有效结束日期
      item.exchangeActivationCodeId = result.exchangeActivationCodeId; //预约导购code
      item.goodsId = result.exchangeGoodsId; // 权益品id
      item.collectionType = item.groupVOList[index].collectionType; // 领取类型
      item.goodsPictureUrl = item.groupVOList[index].activityGoodsImg; // 权益品图片
      item.rewardName = item.groupVOList[index].exchangeGoodsName; // 权益品名
      item.bigWheelActivityType = 1; // 由于中奖弹框背景图PC不配置,因此写死
      item.isBeneficial = true; // 从专题活动权益品楼层跳转到中奖弹框的标志
      item.usedFlag = result.usedFlag;
      item.activationCode = result.activationCode;
      if (item.groupVOList[index].appointmentFlag === '1') {
        item.appointmentFlag = '1'; //权益品配置需预约导购
      } else {
        // 不需要这个值的情况就要删掉
        delete item.appointmentFlag;
      }
      this.awardObj = item;
      let isNext = false;
      try {
        const params = {
          activityCode: result.activityCode,
          rewardRecodeId: (item.groupVOList[index] && item.groupVOList[index].rewardRecodeId) || result.rewardRecodeId || '',
          goodsId: result.exchangeGoodsId,
        };
        isNext = await getValidity(params, (item.groupVOList[index] && item.groupVOList[index].exchangeGoodsType) || '');
      } catch (err) {
        console.log(err);
      }

      setTimeout(() => {
        // 权益品配置了“需要预约导购”
        if (item.appointmentFlag === '1') {
          // 虚拟权益品 - 预约导购 - 线下核销、线下核销（发串码）
          if (
            item.groupVOList[index].exchangeGoodsType === ExchangeGoodsType.virtualAward &&
            (item.collectionType === CollectionType.inStore || item.collectionType === CollectionType.checkOffStrCode) &&
            isNext
          ) {
            this.toAppointmentGuide();
          } else if (
            // 实物权益品 - 预约导购 - 到店自提  或 赠品券 - 预约导购
            (item.groupVOList[index].exchangeGoodsType === ExchangeGoodsType.entityAward && item.collectionType === CollectionType.inStore && isNext) ||
            item.groupVOList[index].exchangeGoodsType === ExchangeGoodsType.giftCoupon
          ) {
            this.toAppointmentGuide();
          }
        } else {
          // 不需要预约导购
          // 实物权益品 - 到店自提 - 不需要预约导购
          if (isNext) {
            // 赠品券collectionType一直未null.赋值成2和虚拟线下核销用同一个弹框组件
            if (item.groupVOList[index].exchangeGoodsType === ExchangeGoodsType.giftCoupon) {
              this.awardObj.collectionType = CollectionType.inStore;
            }
            item.drawOrderSource = null; // 线下核销、预约兑卡密时,此时drawOrderSource=null,需要跳转预约导购
            this.codeShow = true;
          }
        }
      }, 100);
    },
    //实物奖品录入完客户信息再打开实物奖品弹框
    openKindAwardModal() {
      this.$refs.receiveAwardModal.openModel();
    },
    //虚拟奖品录入完客户信息再打开虚拟奖品弹框
    openVirtualAwardModal() {
      this.$refs.virtualAwardModal.openModel();
    },

    //录入信息校验
    nextStep() {
      let self = this;
      if (self.nextActivityCode.indexOf('http') == -1 && self.nextActivityCode.indexOf('https') == -1 && self.nextActivityCode.indexOf('HD') > -1) {
        let path = '/hdmain?activityCode=' + self.nextActivityCode;
        self.$router.push({
          path: path,
        });
        self.$store.commit('base/setIsRouterAlive', false);
        self.$nextTick(() => self.$store.commit('base/setIsRouterAlive', true));
      } else {
        let currentOrigin = window.location.origin;
        if (self.nextActivityCode.indexOf(currentOrigin) > -1 && self.nextActivityCode.indexOf('hdmain') > -1) {
          let path = '/hdmain?' + self.nextActivityCode.split('?')[1];
          self.$router.push({
            path: path,
          });
          self.$store.commit('base/setIsRouterAlive', false);
          self.$nextTick(() => self.$store.commit('base/setIsRouterAlive', true));
        } else {
          window.location.href = self.nextActivityCode;
        }
      }
    },
    // 埋码时间：领取权益品楼层、代金券楼层
    handleClickFloorProcess(type) {
      let actionCode = '';
      let actionName = '';
      let title = '';
      switch (type) {
        // 权益包
        case 'equityPackage':
          {
            actionCode = '400060014';
            actionName = '权益包';
            title = '权益包';
          }
          break;
        default:
          console.log('埋码楼层类型不存在！');
      }
      const params = {
        actionCode: actionCode,
        actionName: actionName,
        content: {
          title: title,
          channel: this.loginType == 'none' ? '无需登陆' : this.loginType == 'wechat' ? '微信' : '支付宝',
          activityCode: this.activityCode,
        },
      };
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      }
      utils.handleBatchReport(this, params);
    },
    //  获取权益品-页面跳转
    getExchangeGoodsToUrl(url) {
      // 链接为积分商城
      if (pointsMallLinkJudge(url) !== PMLinkType.notMatch) {
        jumpToPointsMall(this.activityCode, url);
        return;
      }
      if (this.loginType === 'wechat') {
        // 小程序环境
        if (url.indexOf('pages/webView/activity-web-view?webViewSrc') >= 0) {
          // 1.如果是小程序webview页面，就直接跳转https地址 /pages/webView/activity-web-view?we
          const toUrl = url.split('webViewSrc=')[1];
          window.location.href = toUrl;
        } else if (url.indexOf('http') >= 0) {
          // 2.如果是http地址，就直接跳转
          window.location.href = url;
        } else if (url.indexOf('pages/tabBar/') >= 0) {
          // 3.如果是小程序首页的几个tab页面，用switchTab方法跳转
          wx.miniProgram.switchTab({
            url: url,
          });
        } else if (url.indexOf('subpackages') >= 0) {
          wx.miniProgram.navigateTo({
            url: url,
          });
        }
      } else if (this.loginType === 'Alipay') {
        if (this.miniprogramFlag) {
          // 支付宝小程序环境
          if (url.indexOf('pages/webView/activity-web-view?webViewSrc') >= 0) {
            // 1.如果是小程序webview页面，就直接跳转https地址 /pages/webView/activity-web-view?we
            const toUrl = url.split('webViewSrc=')[1];
            window.location.href = toUrl;
          } else if (url.indexOf('http') >= 0) {
            // 2.如果是http地址，就直接跳转
            window.location.href = url;
          } else if (url.indexOf('pages/tabBar/') >= 0) {
            // 3.如果是小程序首页的几个tab页面，用switchTab方法跳转
            my.switchTab({
              url: url,
            });
          } else if (url.indexOf('subpackages') >= 0) {
            my.navigateTo({
              url: url,
            });
          }
        } else {
          // 支付宝H5环境
          const linkArr = url.split('?');
          let href = '';
          if (linkArr.length > 1) {
            if (linkArr[1].includes('skuCode') || linkArr[1].includes('spuCode')) {
              if (linkArr[0].includes('product-details-global')) {
                href = `alipays://platformapi/startapp?appId=2021002121684220&page=${linkArr[0]}&query=${encodeURIComponent(linkArr[1])}`;
              } else {
                href = `alipays://platformapi/startapp?appId=2021002121684220&page=${linkArr[0]}?${encodeURIComponent(linkArr[1])}`;
              }
            } else {
              href = `alipays://platformapi/startapp?appId=2021002121684220&page=${linkArr[0]}?${encodeURIComponent(linkArr[1])}`;
            }
          } else {
            href = `alipays://platformapi/startapp?appId=2021002121684220&page=${url}`;
          }

          window.location.href = href;
        }
      }
    },
    // 代金券-去使用
    getVoucherToUrl(url) {
      if (url) {
        const parentPageInfo = `&parentPage=thematicActivity&parentActivityCode=${this.activityCode}`;
        if (url.indexOf('pages/webView/activity-web-view?webViewSrc') >= 0) {
          // 1.如果是小程序webview页面，就直接跳转https地址 /pages/webView/activity-web-view?we
          const toUrl = url.split('webViewSrc=')[1];
          window.location.href = toUrl + parentPageInfo;
        } else if (url.indexOf('http') >= 0) {
          // 2.如果是http地址，就直接跳转
          window.location.href = url + parentPageInfo;
        } else if (url.indexOf('pages/tabBar/') >= 0) {
          // 3.如果是小程序首页的几个tab页面，用switchTab方法跳转
          wx.miniProgram.switchTab({
            url: url,
          });
        } else if (url.indexOf('subpackages') >= 0) {
          wx.miniProgram.navigateTo({
            url: url,
          });
        } else {
          wx.miniProgram.navigateTo({
            url: '/subpackages/my/pages/couponList/coupon-list',
          });
        }
      } else {
        wx.miniProgram.navigateTo({
          url: '/subpackages/my/pages/couponList/coupon-list',
        });
      }
    },
    // 权益品-去使用
    toUseDetails(item, index) {
      if (item.groupVOList[index].exchangeGoodsType === ExchangeGoodsType.coupon) {
        this.toUseCoupon(item, index);
      } else if (item.groupVOList[index].exchangeGoodsType === ExchangeGoodsType.accumulatePoints) {
        // 积分-去使用，跳转积分商城
        jumpToPointsMall(this.activityCode);
      } else {
        const params = {
          activityId: item.activityId,
          activityCode: item.activityCode,
          unionId: this.userBase.unionid,
          nickName: this.userBase.nickName || '',
          awardType: item.pageType,
          userHeadPortraitUrl: this.userBase.headimgurl,
          activityPageId: item.id,
          exchangeGoodsGroupCode: item.activityPageRewardSettingList[0].exchangeGroupCode,
        };
        this.goodsIndex = index;
        // 权益品类型：实物、虚拟、代金券、赠品券
        params.exchangeGoodsId = item.groupVOList[index].id;
        params.exchangeGoodsCode = item.groupVOList[index].exchangeGoodsCode;
        params.exchangeGoodsName = item.groupVOList[index].exchangeGoodsName;
        params.exchangeGoodsType = item.groupVOList[index].exchangeGoodsType;
        this.$api.post({
          sc: 'mobileMarketing',
          url: 'h5/projectActivity/awardRedemptionDetail',
          params: params,
          success: async (r) => {
            if (r.code === 200) {
              if (r.result) {
                let isNext = false;
                try {
                  // 虚拟权益品-线上兑换
                  if (
                    item.groupVOList[index].exchangeGoodsType === ExchangeGoodsType.virtualAward &&
                    item.groupVOList[index].collectionType === CollectionType.expressOrOnlineCheckOff
                  ) {
                    // 用户未领取卡密
                    if (!r.result.activationCode) {
                      const params = {
                        activityCode: r.result.activityCode,
                        rewardRecodeId: item.groupVOList[index].rewardRecodeId || r.result.rewardRecodeId || '',
                        goodsId: r.result.exchangeGoodsId,
                      };
                      isNext = await getValidity(params, item.groupVOList[index].exchangeGoodsType);
                    }
                  } else {
                    // 其他权益品
                    const params = {
                      activityCode: r.result.activityCode,
                      rewardRecodeId: item.groupVOList[index].rewardRecodeId || r.result.rewardRecodeId || '',
                      goodsId: r.result.exchangeGoodsId,
                    };
                    isNext = await getValidity(params, item.groupVOList[index].exchangeGoodsType);
                  }
                } catch (err) {
                  console.log(err);
                }
                setTimeout(() => {
                  if (item.groupVOList[index].exchangeGoodsType === ExchangeGoodsType.voucher) {
                    // 代金券-去使用
                    this.getVoucherToUrl(r.result.voucherUrl);
                  } else {
                    if (
                      item.groupVOList[index].collectionType === '1' &&
                      item.groupVOList[index].exchangeGoodsType === '0' &&
                      item.groupVOList[index].useStatus === '13' &&
                      (isNext || r.result.activationCode)
                    ) {
                      // 虚拟-线上兑换-去使用
                      this.isReceived = true;
                      this.awardObj = r.result;
                      this.awardObj['jumpUrl'] = item.groupVOList[index].jumpUrl || '';
                      this.$refs.virtualOnlineAwardModal.openModel();
                    } else if (
                      item.groupVOList[index].collectionType === '1' &&
                      item.groupVOList[index].exchangeGoodsType === '1' &&
                      item.groupVOList[index].useStatus === '02' &&
                      isNext
                    ) {
                      // 实物-线上邮寄-去使用
                      this.awardObj = r.result;
                      this.awardObj['jumpUrl'] = item.groupVOList[index].jumpUrl || '';
                      this.$refs.realOnlineMailingModal.modalCancel();
                      this.getExchangeGoodsToUrl(this.awardObj['jumpUrl']);
                    } else {
                      // 1.权益品实物+到店自提； 2.权益品虚拟+线下核销发卡密 ； 3.权益品虚拟+线下核销
                      this.handleExchangeGoodsData(item, index, r.result, false);
                    }
                  }
                }, 100);
              }
            } else {
              const msg = r.message ? r.message : '出错啦，请稍后再试';
              Toast(msg);
            }
          },
          failure: (error) => {
            console.log('err======', error);
            Toast('出错了，请稍后再试');
          },
        });
      }
    },
    // 虚拟-线上兑换，提交姓名电话信息
    fillInUserInfo(msg) {
      const item = msg[0];
      const index = msg[1];
      let params = {
        activityId: item.activityId,
        activityCode: item.activityCode,
        exchangeGoodsId: item.groupVOList[index].id,
        exchangeGoodsCode: item.groupVOList[index].exchangeGoodsCode,
        exchangeGoodsType: item.groupVOList[index].exchangeGoodsType,
        collectionType: item.groupVOList[index].collectionType,
        exchangeGoodsGroupCode: item.activityPageRewardSettingList[0].exchangeGroupCode,
        pageType: 'group',
      };
      if (this.userInfoList && this.userInfoList.length === 0) {
        params.userInfo = { userName: msg[2], userPhone: msg[3] };
      } else {
        params.userInfo = {userInfoList: msg[2].userInfoList}
      }
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/fillInUserInfo',
        params: params,
        success: (r) => {
          if (r && r.code === 200 && r.result) {
            if (this.activityPausedHandler(r)) {
              // 虚拟-线上兑换，信息提交成功，按钮：去填写 → 去使用
              item.goodsList[index].useStatus = useStatus.toUse;
              item.groupVOList[index].useStatus = useStatus.toUse;
              this.isReceived = true;
              this.item.activationCode = r.result;
              Toast('提交成功');
            } else {
              this.$refs.virtualOnlineAwardModal.modalCancel();
            }
          } else {
            this.receiveFailedHandler(r, index);
          }
        },
        failure: (error) => {
          console.log('err======', error);
          Toast('出错了，请稍后再试');
        },
      });
    },
    //实物-线上邮寄，提交收件信息
    handleRealOnlineMailing(msg) {
      const item = msg[0];
      const index = msg[1];
      const info = msg[2];
      const params = {
        activityId: item.activityId,
        activityCode: item.activityCode,
        exchangeGoodsId: item.groupVOList[index].id,
        exchangeGoodsCode: item.groupVOList[index].exchangeGoodsCode,
        exchangeGoodsType: item.groupVOList[index].exchangeGoodsType,
        exchangeGoodsGroupCode: item.activityPageRewardSettingList[0].exchangeGroupCode,
        collectionType: item.groupVOList[index].collectionType,
        pageType: 'group',
        userInfo: {
          userName: info.userName,
          userPhone: info.userPhone,
          userAddress: info.userAddress,
          userCountryName: info.userCountryName,
          userProvinceName: info.userProvinceName,
          userCityName: info.userCityName,
          userZoneName: info.userZoneName,
        },
      };
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/fillInUserInfo',
        params: params,
        success: (r) => {
          if (r && r.code === 200) {
            if (this.activityPausedHandler(r)) {
              Toast('提交成功');
              // 实物-线上邮寄，信息提交成功，按钮：去填写 → 已领取
              item.goodsList[index].useStatus = useStatus.received;
              item.groupVOList[index].useStatus = useStatus.received;
            }
            this.$refs.realOnlineMailingModal.modalCancel();
          } else {
            this.receiveFailedHandler(r, index);
          }
        },
        failure: (error) => {
          console.log('err======', error);
          Toast('出错了，请稍后再试');
        },
      });
    },
    // 活动暂停处理
    activityPausedHandler(res) {
      if (res.result === 'ACTIVITY_IS_PAUSED') {
        if (this.backgroundType) {
          this.activitySuspended = true;
        } else {
          this.$emit('paused');
        }
        return false;
      } else {
        return true;
      }
    },
    timeDownFinished(index) {
      this.item.goodsList[index].useStatus = '01';
    },
    // 跳转预约导购
    async toAppointmentGuide() {
      const { result } = await this.checkShoppingGuide(this.awardObj.exchangeActivationCodeId);
      this.path =
        result && result.guideId
          ? `subpackages/activity/pages/shoppersService/serviceDetail/service-detail?id=${result.guideId}&activityUrl=${this.activityUrl}`
          : `subpackages/activity/pages/shoppersService/createService/create-service?activationCodeId=${this.awardObj.exchangeActivationCodeId}&collectionType=${this.awardObj.collectionType}&drawType=${this.drawType}&activityUrl=${this.activityUrl}`;
      let url = `/${this.path}`;
      const userBase = sessionStorage.getItem('userInfo');
      if (!userBase) {
        url += '&refresh=1';
      } else if (!userBase.member) {
        url += '&refresh=1';
      }
      sessionStorage.setItem('needRefreshPage', true);
      if (this.loginType === 'wechat') {
        wx.miniProgram.navigateTo({
          url: url,
          success: function () {
            console.log('跳转回小程序的页面success');
          },
          fail: function (res) {
            console.log('跳转回小程序的页面fail', res);
          },
        });
      } else {
        if (this.miniprogramFlag) {
          // 支付宝环境
          my.navigateTo({
            url: url,
          });
        } else {
          // 支付宝H5环境
          window.location.href = `alipays://platformapi/startapp?appId=2021002121684220&page=${url}`;
        }
      }
    },
    closeEnd() {
      this.codeShow = false;
    },
    //检测是否已经预约成功了
    checkShoppingGuide(id) {
      return new Promise((resolve, reject) => {
        this.$api.get({
          noLoading: true,
          sc: 'mobileMarketing',
          url: `guide/getGuideByActivationCodeId/${id}`,
          params: null,
          success: (r) => {
            resolve(r);
          },
          failure: (error) => {
            console.log('err======', error);
            Toast('出错了，请稍后再试');
          },
        });
      });
    },
    getPackageRecTime(item) {
      if (item && item.activityPageRewardSettingList) {
        return `${
          (item.activityPageRewardSettingList[0].effectiveStartTime && item.activityPageRewardSettingList[0].effectiveStartTime.split(' ')[0]) || ''
        } ~ ${(item.activityPageRewardSettingList[0].effectiveEndTime && item.activityPageRewardSettingList[0].effectiveEndTime.split(' ')[0]) || ''}`;
      } else {
        return '';
      }
    },
    getProductRecTime(item) {
      if (item && item.pickupStartTime && item.pickupEndTime) {
        return `${(item.pickupStartTime && item.pickupStartTime.split(' ')[0]) || ''} ~ ${(item.pickupEndTime && item.pickupEndTime.split(' ')[0]) || ''}`;
      } else{
        return '';
      }
    },
    initData() {},
    handleClickOpen() {
      this.showBeneficialProducts = !this.showBeneficialProducts;
    },
  },
};
</script>
<style lang="scss" scoped>
.product-title {
  font-size: 14px;
  height: 17px;
  color: #000000;
  line-height: 17px;
  font-weight: 500;
}
.receive-time {
  font-size: 11px;
  color: #999999;
  line-height: 13px;
  height: 13px;
  font-weight: 400;
  margin-top: 2px;
}
.count {
  font-size: 12px;
  font-weight: 400;
  padding-right: 10px;
  color: #848484;
  letter-spacing: 0;
  line-height: 13px;
}

.btn-user-vip {
  display: flex;
  align-items: center;
  margin-top: 18px;
  margin-right: 12px;
  .get-btn {
    width: 68px;
    height: 24px;
    .get-btn-img {
      width: 100%;
      height: 100%;
    }
  }
}
.package-contain {
  background-color: #ffffff;
  width: 92vw;
  position: relative;
  left: 4vw;
  border-radius: 6px;
}
.package-item {
  position: relative;
  .large-contain {
    background: #ffffff;
    border-radius: 6px;
    margin-bottom: 10px;
    overflow: hidden;
    display: flex;
    align-items: center;
    width: 92vw;
    margin: 0 auto;
    height: 26.67vw;
    .price-contain {
      width: 20.67vw;
      height: 20.67vw;
      margin-left: 2.3vw;
      margin-right: 1.6vw;
      .main-img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
      }
      .use-condition {
        border: 1px solid red;
        height: 22px;
        line-height: 22px;
        width: 60%;
        border-radius: 22px;
        text-align: center;
        margin-top: 16px;
      }
      .beneficial-des {
        font-size: 16px;
        margin-top: 8px;
      }
    }
    .product-info {
      flex-grow: 1;
      padding-top: 5px;
      max-width: 62.8vw;
      height: 20.67vw;
    }
    .btn-contain {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .time {
        margin-top: 15px;
        display: flex;
        .time-bg {
          background-color: #e0e0e0;
          margin-left: 3px;
          margin-right: 3px;
          padding-left: 2px;
          padding-right: 2px;
          border-radius: 3px;
        }
      }
      .time-down {
        height: 30px;
      }

      .coupon-received {
        position: absolute;
        right: 20px;
        top: 5px;
        width: 16.4vw;
      }
      .received-btn {
        width: 68px;
        height: 24px;
        line-height: 24px;
        border-radius: 26px;
        background-color: #dddddd;
        color: #ffffff;
        text-align: center;
      }
      .not-received-btn {
        width: 68px;
        height: 24px;
        margin-top: 1.333vw;
        .not-received-btn-img {
          width: 100%;
          height: 100%;
        }
      }
      .margin-top-btn {
        margin-top: 0;
      }
    }
  }
  .large-contain-mask {
    height: 26.67vw;
    width: 92%;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0px;
    left: 4%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    .use-btn {
      width: 21.333vw;
      height: 6.4vw;
      .use-btn-img {
        width: 100%;
        height: 100%;
      }
    }
    .use-out {
      height: 24px;
      line-height: 24px;
      padding-left: 15px;
      padding-right: 15px;
      border-radius: 24px;
      color: #ffffff;
    }
  }
  .bottom-btn {
    display: flex;
    justify-content: space-between;
    width: 100%;
    .open-icon {
      position: relative;
      top: 16px;
      left: 5px;
      display: inline-block;
      color: #999;
      .open-img {
        height: 8px;
        position: relative;
        top: 1px;
      }
    }
    .main-btn-user-vip {
      display: flex;
      align-items: center;
      margin-top: 5px;
      position: relative;
      .user-vip {
        margin-right: 6px;
        font-size: 12px;
        color: #848484;
        line-height: 13px;
        font-weight: 400;
      }
      .main-btn {
        font-size: 12px;
        color: #848484;
        line-height: 13px;
        font-weight: 400;
        height: 24px;
        width: 74px;
        background-color: #256fff;
        color: #fff;
        text-align: center;
        line-height: 24px;
        border-radius: 24px;
      }
      .get-btn {
        width: 68px;
        height: 24px;
        .get-btn-img {
          width: 100%;
          height: 100%;
        }
      }
      .received-btn {
        width: 68px;
        height: 24px;
        line-height: 24px;
        border-radius: 26px;
        background-color: #dddddd;
        color: #ffffff;
        text-align: center;
      }
    }
  }
}
.bottom-line {
  border-bottom: dashed 1px #0000007d;
  height: 1px;
  width: 86vw;
  position: relative;
  bottom: 10px;
  left: 3vw;
}
.beneficial-item-large {
  padding-bottom: 10px;
  position: relative;
  .large-contain {
    position: relative;
    background: #f9f9f9;
    border-radius: 6px;
    margin-bottom: 10px;
    overflow: hidden;
    display: flex;
    align-items: center;
    width: 87vw;
    margin: 0 auto;
    height: 26.67vw;
    // 代金券角标
    .voucher-corner {
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      height: 4vw;
      width: 10.9vw;
      .voucher-corner-img {
        width: 100%;
        height: 100%;
      }
    }
    .price-contain {
      width: 20.67vw;
      height: 20.67vw;
      margin-left: 2.3vw;
      margin-right: 1.6vw;
      .main-img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
      }
      .use-condition {
        border: 1px solid red;
        height: 22px;
        line-height: 22px;
        width: 60%;
        border-radius: 22px;
        text-align: center;
        margin-top: 16px;
      }
      .beneficial-des {
        font-size: 16px;
        margin-top: 8px;
      }
    }
    .product-info {
      flex-grow: 1;
      padding-top: 5px;
      max-width: 62.8vw;
      height: 20.67vw;
    }
    .btn-contain {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .time {
        margin-top: 15px;
        display: flex;
        .time-bg {
          background-color: #e0e0e0;
          margin-left: 3px;
          margin-right: 3px;
          padding-left: 2px;
          padding-right: 2px;
          border-radius: 3px;
        }
      }
      .time-down {
        height: 30px;
      }

      .coupon-received {
        position: absolute;
        right: 20px;
        top: 5px;
        width: 16.4vw;
      }

      .received-btn {
        width: 68px;
        height: 24px;
        line-height: 24px;
        border-radius: 26px;
        background-color: #dddddd;
        color: #ffffff;
        text-align: center;
      }
      .to-fill-in-btn {
        width: 68px;
        height: 24px;
        line-height: 24px;
        border-radius: 26px;
        background-color: #256fff;
        color: #ffffff;
        text-align: center;
      }
      .not-received-btn {
        width: 68px;
        height: 24px;
        margin-top: 1.333vw;
        .not-received-btn-img {
          width: 100%;
          height: 100%;
        }
      }
      .margin-top-btn {
        margin-top: 0;
      }
    }
  }
  .large-contain-mask {
    height: 26.67vw;
    width: 92%;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0px;
    left: 4%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    .use-btn {
      width: 21.333vw;
      height: 6.4vw;
      .use-btn-img {
        width: 100%;
        height: 100%;
      }
    }
    .use-out {
      height: 24px;
      line-height: 24px;
      padding-left: 15px;
      padding-right: 15px;
      border-radius: 24px;
      color: #ffffff;
    }
  }
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; /* 保证不换行 */
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/themaicComponent/equity-package.vue